export type ChurchBookSearchType = 'person' | 'family' | 'event';

export type ChurchBookOperator =
  'eq' | 'ne' | 'ct' | 'sw' | 'ew' | 'bw' | 'in' | 'nin' | 'gte' | 'lte' | 'gt' | 'lt' | 'ex';

export interface ChurchBookCondition {
  field: string;
  operator: ChurchBookOperator;
  value: string | number | string[] | number[];
}

export interface ChurchBookFilterGroup {
  logic: 'AND' | 'OR';
  conditions: ChurchBookCondition[];
}

export interface ChurchBookSearchRequest {
  search_type: ChurchBookSearchType;
  filter_group: ChurchBookFilterGroup;
  limit: number;
  offset: number;
}

export interface ChurchBookMetadata {
  total_count: number;
  limit: number;
  offset: number;
  returned_count: number;
  has_more: boolean;
  query_time_ms: number;
  facets: null;
}

export interface PersonResult {
  id: string;
  full_name: string;
  birth_date: string;
  birthplace: string;
  parent_info: { father: string; mother: string };
  events_count: number;
  families_count: number;
}

export interface FamilyResult {
  id: string;
  family_name: string;
  surname: string;
  member_count: number;
  root_person_name: string;
  members: { full_name: string; role: string }[];
}

export interface EventResult {
  id: string;
  event_type: number;
  event_date: string;
  location: string;
  parish: string;
  participant_count: number;
  registry_page: number;
}

export interface ChurchBookSearchResponse {
  success: boolean;
  message?: string;
  metadata: ChurchBookMetadata;
  results: PersonResult[] | FamilyResult[] | EventResult[];
}

export interface ChurchBookAuthResponse {
  token: string;
}

export const EVENT_TYPE_LABELS: Record<number, string> = {
  1: 'Birth',
  2: 'Residence',
  3: 'Migration',
  4: 'Baptism',
  5: 'Marriage',
  6: 'Divorce',
  7: 'Death',
  8: 'Burial',
  9: 'Confirmation',
  10: 'Communion',
};
